import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef } from 'vue';
import SimpleModal from './SimpleModal.vue';
import { type Prompt, usePrompt } from '@/composables/usePrompt';
import { useCounter, useInterval } from '@vueuse/core';

const COUNTER_START = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'PromptHandler',
  setup(__props, { expose: __expose }) {
  __expose();

const { usePromptHandler, events } = usePrompt();

const currentPrompt = shallowRef<Prompt | null>(null);
const responseValue = ref<string | null>(null);

const { dec, count, reset } = useCounter();
const { pause, resume } = useInterval(1000, {
	controls: true,
	callback: () => {
		dec();
		if(count <= 0) pause();
	}
});

usePromptHandler(prompt => {
	currentPrompt.value = prompt;
	if(prompt.timeout) {
		reset(COUNTER_START);
		resume();
	}
});

function handleAck() {
	events.emit("response_ack");
	currentPrompt.value = null;
}

function handleChoice() {
	events.emit("response_choice", responseValue.value);
	responseValue.value = null;
	currentPrompt.value = null;
}

function handleYesNo(res: boolean) {
	events.emit("response_boolean", res);
	currentPrompt.value = null;
}

function handleQuery(res: string | null) {
	events.emit("response_query", res);
	currentPrompt.value = null;
	responseValue.value = null;
}



const __returned__ = { usePromptHandler, events, currentPrompt, responseValue, COUNTER_START, dec, count, reset, pause, resume, handleAck, handleChoice, handleYesNo, handleQuery, ref, shallowRef, SimpleModal, get usePrompt() { return usePrompt }, get useCounter() { return useCounter }, get useInterval() { return useInterval } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})